module.exports = __webpack_public_path__ + "static/img/glj.718414e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/glj.png
// module id = yLw3
// module chunks = 1